import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocaleStringMap } from 'shared';

@Pipe({
    name: 'fromLocaleStringMap',
    pure: false,
})
export class FromLocaleStringMapPipe implements PipeTransform {
    private translate = inject(TranslateService);

    public transform(value: unknown, ...args: Array<unknown>): string | null {
        if (typeof value === 'object') {
            return this.getTranslation(value as LocaleStringMap, (args || [])[0] as Record<string, string>);
        } else if (typeof value === 'string') {
            return value;
        }
        return null;
    }

    public getTranslation(name: LocaleStringMap, replacements?: Record<string, string>): string | null {
        if (!name) return null;
        if (name['default']) {
            name[this.translate.defaultLang] = name['default'];
        }

        const value = name[this.translate.currentLang] ?? name[this.translate.defaultLang] ?? '';
        if (replacements && typeof value === 'string') {
            return Object.entries(replacements).reduce(
                (result, [key, val]) => result.replaceAll(`{{${key}}}`, val),
                value
            );
        }
        return value as string;
    }
}
